import {
  isNull,
  isUndefined
} from "util";
export default {
  /**
   * 生成菜单树数据
   * @param {*} data  数据
   * @param {*} fid
   */
  creatMenuJson (data, fid) {
    let arr = []
    for (let i = 0; i < data.length; i++) {
      if (data[i].parentId == fid) {
        let item = {}
        item = data[i]
        item.children = this.creatMenuJson(data, data[i].id)
        if (item.children.length > 0) {
          item.component = fid == 0 ? 'Layout' : 'none'
        }
        arr.push(item)
      }
    }
    return arr
  },
  /**
   * 树状结构数组扁平化
   * @param {*} arr  树结构数据
   */
  treeArrToArr (arr) {
    let result = []
    for (let node of arr) {
      var res = JSON.parse(JSON.stringify(node)) // 先克隆一份数据作为第一层级的填充
      delete res['children']
      result.push(res)
      if (node.children instanceof Array && node.children.length > 0) {
        // 如果当前child为数组并且长度大于0，才可进入flag()方法
        result = result.concat(this.treeArrToArr(node.children))
      }
    }
    return result
  },
  /**
   * 生成树数据
   * @param {*} data  数据
   * @param {*} fid
   */
  creatTreeJson (data, fid) {
    let arr = []
    for (let i = 0; i < data.length; i++) {
      if (data[i].parentId == fid) {
        let item = {}
        item = data[i]
        item.children = this.creatTreeJson(data, data[i].id)
        arr.push(item)
      }
    }
    return arr
  },
  /**
   * 生成树数据
   * @param {*} data  数据
   * @param {*} fid
   */
  creatTreeJson2 (data, idKeyName, parentIdKeyName, parentId) {
    let arr = []
    for (let i = 0; i < data.length; i++) {
      if (data[i][parentIdKeyName] == parentId) {
        let item = {}
        item = data[i]
        item.children = this.creatTreeJson(data, data[i][idKeyName])
        arr.push(item)
      }
    }
    return arr
  },
  /**
   * 数据转树结构并计算电量损耗
   */
  dataToTreeDataForCalcEle (data, parentId) {
    let arr = []
    for (let i = 0; i < data.length; i++) {
      if (data[i].parentId == parentId) {
        let item = data[i]
        item.loss = '' //损耗
        item.scale = '' //比例
        item.children = this.dataToTreeDataForCalcEle(data, item.id)
        if (item.children.length > 0) {
          let sum = 0
          for (let k = 0; k < item.children.length; k++) {
            let v = item.children[k].value
            if (!isNaN(v) && !isNull(item.v)) {
              sum += v
            }
          }

          if (isNaN(item.value) || isNull(item.value)) {
            item.loss = ''
            item.scale = ''
          } else {
            item.loss = item.value - sum
            item.scale =
              item.value === 0
                ? '-'
                : ((item.loss / item.value) * 100).toFixed(2) + '%'
            item.loss = item.loss.toFixed(2)
          }
        }
        item.displayValue =!item.value
          ? null
          : item.value.toFixed(2)
        item.measureName =
          item.children.length > 0
            ? '|-- ' + item.measureName
            : '  |-- ' + item.measureName
        let indexI = item.measureName.lastIndexOf('|--') //|--最后一次出现的位置
        item.measureName = item.measureName.slice(indexI)
        arr.push(item)
      }
    }
    return arr
  },

  creatMeasureTreeJson (data, fid, obj) {
    let arr = []
    for (let i = 0; i < data.length; i++) {
      if (data[i].parentId == fid) {
        let item = {}
        item = data[i];
        item.children = this.creatMeasureTreeJson(data, data[i].measureId);
        if (obj) {
          item = Object.assign(item, obj)
        }
        arr.push(item)
      }
    }
    return arr
  }

}
